module.exports = __webpack_public_path__ + "img/the-netherlands-cardiovascular-diseases-female.f9958b21.png";